import {Link, LinkProps} from "react-router-dom";

interface DashboardTableRowProps {
    name: string
    value: number | string | boolean | undefined
    linkProps?: LinkProps
    className?: string
}

export const DashboardTableRow = ({name, value, linkProps, className} : DashboardTableRowProps) =>
{
    return (
        <tr className="text-nowrap">
            <td>
                {name}
            </td>
            <td className={"text-end " + className} >
                {linkProps !== undefined && <Link {...linkProps}>{value?.toString() ?? "?"}</Link>}
                {linkProps === undefined && (value?.toString() ?? "?")}
            </td>
        </tr>
   )
}